<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row align-v="center" class="py-4">
				<b-col cols="7" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">OTA Activate</h6>
					&nbsp;
				</b-col>
				<b-col cols="5" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>

			<div v-if="noAccess">
				<b-card>
					<b-card-header>
						<p class="h2 mb-2">
							<b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
							>&nbsp;Restricted
						</p>
					</b-card-header>
					<b-card-body>Access is Restricted</b-card-body>
				</b-card>
			</div>
			<div v-else>
				<b-row class="mb-4">
					<b-col xl="6">
						<b-input-group size="lg">
							<template #prepend>
								<b-button class="iccid-width ps" style="cursor: default" variant="primary"
									>ICCID
								</b-button>
							</template>
							<b-form-input
								id="iccid"
								type="text"
								v-model="iccid"
								data-cy="ota-activate-search-input"
							></b-form-input>
							<b-input-group-append>
								<b-button
									data-cy="ota-activate-search-btn"
									size="lg"
									variant="success"
									title="Search"
									v-on:click="getProfileData"
								>
									<i class="fa fa-search"></i>
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-col>
					<b-col xl="6"></b-col>
				</b-row>

				<b-row v-if="submitLoading" class="text-center">
					<b-col cols="12">
						<b-card no-body>
							<b-card-body>
								<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>

				<b-row v-if="!hasData && !submitLoading">
					<b-col xl="12">
						<b-card no-body>
							<b-card-body>
								<div class="text-center">{{ systemMessage }}</div>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>

				<b-row v-if="hasData">
					<b-col xl="9">
						<b-card>
							<b-row v-if="isAdministrator || isPortalAdmin">
								<b-col class="offset-9">
									<div class="d-flex align-items-center pr-3">
										<BaseSwitch
											class="base-switch ml-auto"
											:class="isMinimal ? 'bg-secondary' : 'bg-primary'"
											v-model="isMinimal"
											style="border-radius: 12px; width: 75px"
											offText="Detailed"
											onText="Minimal"
										/>
									</div>
								</b-col>
							</b-row>
							<b-card-body class="p-sm-3 p-0">
								<div class="input-group">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">ICCID</b-input-group-text>
										</template>
										<b-form-input
											id="iccid"
											type="text"
											v-model="iccid"
											readonly
											data-cy="ota-activate-form-iccid"
										></b-form-input>
									</b-input-group>
								</div>
								<div class="input-group">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">CARRIER</b-input-group-text>
										</template>
										<b-form-input
											id="carrier"
											type="text"
											v-model="carrier"
											readonly
										></b-form-input>
									</b-input-group>
								</div>
								<div class="input-group" v-if="technology !== 'cdma'">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">MSISDN</b-input-group-text>
										</template>
										<b-form-input
											data-cy="ota-activate-form-msisdn"
											id="msisdn"
											type="tel"
											v-model="msisdn"
											maxlength="12"
											:disabled="isReadOnly"
										></b-form-input>
									</b-input-group>
								</div>
								<div class="input-group" v-if="technology !== 'gsm'">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">MDN</b-input-group-text>
										</template>
										<b-form-input
											id="mdn"
											type="tel"
											v-model="mdn"
											maxlength="12"
											:disabled="isReadOnly"
										></b-form-input>
									</b-input-group>
								</div>
								<div class="input-group" v-if="technology !== 'gsm'">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">MIN</b-input-group-text>
										</template>
										<b-form-input
											id="min"
											type="tel"
											v-model="min"
											maxlength="12"
											:disabled="isReadOnly"
										></b-form-input>
									</b-input-group>
								</div>

								<!-- Dynamically load files -- Noriel F. -->
								<div class="input-group" v-for="(file, label, index) in files">
									<b-input-group
										v-if="
											!isMinimal ||
											(isMinimal && mimnimalFields.includes(label.toString().toLowerCase()))
										"
									>
										<template #prepend>
											<b-input-group-text :style="ps"
												>{{ label.toString().toUpperCase() }}
											</b-input-group-text>
										</template>
										<b-form-input
											v-if="/<.*>/.test(files_model[index].data.toString())"
											:id="label"
											type="text"
											:placeholder="files_model[index].value.data"
											v-model="files_model[index].value.data"
											:disabled="isReadOnly"
										></b-form-input>
										<b-form-select
											v-else
											:id="label"
											v-model="files_model[index].value"
											:options="newReturnArrMap(file, label)"
											:disabled="isReadOnly"
										></b-form-select>
									</b-input-group>
								</div>

								<div class="input-group" v-if="isPortalAdmin && !isMinimal">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">Tls Key</b-input-group-text>
										</template>
										<b-form-input id="tls" type="text" v-model="tls"></b-form-input>
										<b-icon
											icon="lock-fill"
											variant="danger"
											v-b-tooltip.hover.top="'Only the DCC Portal Admin can see this field'"
										/>
									</b-input-group>
								</div>
								<div class="input-group" v-if="isPortalAdmin && !isMinimal">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">Kic Key</b-input-group-text>
										</template>
										<b-form-input id="kic" type="text" v-model="kic"></b-form-input>
										<b-icon
											icon="lock-fill"
											variant="danger"
											v-b-tooltip.hover.top="'Only the DCC Portal Admin can see this field'"
										/>
									</b-input-group>
								</div>
								<div class="input-group" v-if="isPortalAdmin && !isMinimal">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">Kid Key</b-input-group-text>
										</template>
										<b-form-input id="kid" type="text" v-model="kid"></b-form-input>
										<b-icon
											icon="lock-fill"
											variant="danger"
											v-b-tooltip.hover.top="'Only the DCC Portal Admin can see this field'"
										/>
									</b-input-group>
								</div>
								<div class="input-group" v-if="isPortalAdmin && !isMinimal">
									<b-input-group>
										<template #prepend>
											<b-input-group-text :style="ps">Vendor</b-input-group-text>
										</template>
										<b-form-select
											id="vendor"
											v-model="vendor"
											:options="vendor_options"
											:disabled="isReadOnly"
										></b-form-select>
									</b-input-group>
								</div>
								<!--
                <div class="input-group">
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text :style="ps">HTTPOTA</b-input-group-text>
                    </template>
                    <b-form-select id="can_httpota" v-model="can_httpota" :options="default_options"></b-form-select>
                  </b-input-group>
                </div>
                <div class="input-group">
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text :style="ps">SMSOTA</b-input-group-text>
                    </template>
                    <b-form-select id="smsota" v-model="smsota" :options="default_options"></b-form-select>
                  </b-input-group>
                </div>
                <div class="input-group">
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text :style="ps">REISSUE</b-input-group-text>
                    </template>
                    <b-form-select id="reissue" v-model="reissue" :options="default_options"></b-form-select>
                  </b-input-group>
                </div>
                <div class="input-group">
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text :style="ps">RESET</b-input-group-text>
                    </template>
                    <b-form-select id="reset" v-model="reset" :options="default_options"></b-form-select>
                  </b-input-group>
                </div>
                -->
								<br />&nbsp;
								<div align="right" class="flow-root">
									<base-button
										data-cy="ota-activate-form-activate-btn"
										size="xl"
										type="success"
										:hidden="isReadOnly"
										v-on:click="activateAction(0)"
									>
										Activate
									</base-button>
									<base-button
										data-cy="ota-activate-form-records-btn"
										type="primary"
										size="xl"
										:disabled="!activated"
										:hidden="isReadOnly"
										v-on:click="clickRecords"
									>
										Records
									</base-button>
									<base-button
										data-cy="ota-activate-form-reset-btn"
										type="danger"
										size="xl"
										:disabled="!activated"
										:hidden="isReadOnly"
										@click="$bvModal.show('confirm-reset')"
									>
										Reset
									</base-button>
								</div>
								<br />
								<div align="right" v-if="carrier.toLowerCase().includes('inland')">
									<base-button size="xs" type="dark">
										<b>HSS: </b>
										<span>
											<base-button
												v-if="String(state) !== 'ACTIVE'"
												style="padding:unset;!important;"
												size="xs"
												type="success"
												:disabled="!activated"
												:hidden="isReadOnly"
												v-on:click="provisionAction('ACTIVATE')"
											>
												ACTIVATE
											</base-button> </span
										>&nbsp;
										<span>
											<base-button
												v-if="String(state) === 'ACTIVE'"
												style="padding:unset;!important;"
												size="xs"
												type="danger"
												:disabled="!activated"
												:hidden="isReadOnly"
												v-on:click="provisionAction('TERMINATE')"
											>
												TERMINATE
											</base-button>
										</span>
										<br />
										<i>Note: This will add or remove the eSim in the HSS only. </i>
									</base-button>
								</div>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</div>
		</base-header>

		<!-- CONFIRM RESET -->
		<b-modal id="confirm-reset" title="Confirm Reset" hide-footer centered>
			<div class="mt-3 mb-3">
				<p class="text-center">
					Are you sure you want to reset the profile for ICCID:
					<strong class="font-weight-600">{{ iccid }}</strong
					>?
				</p>
			</div>
			<div class="mt-3 mb-3 float-right">
				<base-button type="secondary" v-on:click="$bvModal.hide('confirm-reset')">Cancel</base-button>
				&nbsp;
				<base-button data-cy="ota-activate-form-confirm-reset-btn" type="danger" v-on:click="clickReset">
					Confirm Reset
				</base-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";
import authService from "@/common/api-services/auth-service";
import mobileDashboardService from "@/common/api-services/mobile-dashboard-service";
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import ToastVue from "../../Components/Toast.vue";
import BaseSwitch from "@/components/BaseSwitch";

export default {
	components: {
		RouteBreadCrumb,
		BaseSwitch,
		ToastVue,
	},

	data() {
		return {
			mimnimalFields: [
				"iccid",
				"carrier",
				"msisdn",
				"eprl",
				"oplmn",
				"fplmn",
				"hplmn",
				"mspl",
				"opl",
				"pnn",
				"httppoll",
			],
			isMinimal: true,
			ps: "background-color:rgba(94,114,228);color:#FFFFFF;width:150px",
			submitLoading: false,
			hasData: false,
			systemMessage: "Please enter a valid iccid that exists in the system.",
			carrier: "",
			carrier_options: [],
			files: [], // holding files data - Noriel F.
			files_model: [], // files data model - Noriel F.
			files_model_default: [], // holding original files data - Noriel F.
			item_keys: [], // holding item keys data - Noriel F.
			item_data: [], // holding item data to set value of files- Noriel F.

			imsi: "",
			state: "",
			technology: "",
			iccid: "",
			msisdn: "",
			mdn: "",
			min: "",
			eprl: "",
			eprl_options: [],
			oplmn: "",
			oplmn_options: [],
			fplmn: "",
			fplmn_options: [],
			hplmn: "",
			hplmn_options: [],
			mspl: "",
			mspl_options: [],
			httppoll: "",
			httppoll_options: [],

			opl: "",
			opl_options: [],

			pnn: "",
			pnn_options: [],

			tls: "",
			kic: "",
			kid: "",
			vendor: "",
			vendor_options: [],
			can_httpota: 0,
			smsota: 0,
			reissue: 0,
			reset: 0,
			activated: true,
			default_options: [
				{value: "", text: "Not Set"},
				{value: "1", text: "Yes"},
				{value: "0", text: " No"},
			],
			data_set: [],
			btn_disabled: false,

			//ACCESS ROLES
			isReadOnly: true,
			isEditor: false,
			isAdministrator: false,
			isPortalAdmin: false,
			progressTitle: null,
			progressMessage: null,
		};
	},

	watch: {
		msisdn: {
			handler: function (value) {
				this.msisdn = commonService.formatPhone(value);
			},
		},
		mdn: {
			handler: function (value) {
				this.mdn = commonService.formatPhone(value);
			},
		},
		min: {
			handler: function (value) {
				this.min = commonService.formatPhone(value);
			},
		},
	},

	mounted() {
		document.title = "OTA - Activate";

		/** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
		 */

		//set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
		this.isReadOnly = initService.getUserRoles().includes("OTA_READ");
		this.isEditor = initService.getUserRoles().includes("OTA_READ");
		this.isAdministrator =
			initService.getUserRoles().includes("PORTAL_ADMIN") ||
			initService.getUserRoles().includes("CARRIER_ADMIN") ||
			initService.getUserRoles().includes("OTA_ADMIN");
		this.isPortalAdmin = initService.getPortalAdminRole();

		//write to console.
		// console.log('PAGE:', document.title)
		// console.log('isReadOnly:', this.isReadOnly);
		// console.log('isEditor:', this.isEditor);
		// console.log('isAdministrator:', this.isAdministrator);
		// console.log('isPortalAdmin:', this.isPortalAdmin);

		//don't do anything unless the user has access
		if (!this.noAccess) {
			if (this.$route.query.iccid !== "" && typeof this.$route.query.iccid !== "undefined")
				this.iccid = this.$route.query.iccid;
			else this.readCache();
			//load page
			this.loadPageData();
		} else {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			// console.log(this.$route.path.split(':')[0])
			// console.log(this.$route.query)
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$route.path.split(":")[0] + ":id");

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
	},
	methods: {
		readCache() {
			//get the last saved filter criteria
			let search = localStorage.getItem(this.$route.name);
			// console.log('reading search:', search);
			if (search) {
				search = JSON.parse(search);
				if (search.iccid && search.iccid !== "") this.iccid = search.iccid;
			}
		},

		writeCache() {
			//set to current filter criteria
			let search = {
				iccid: this.iccid,
			};
			// console.log('writing search:', search);
			localStorage.setItem(this.$route.name, JSON.stringify(search));
		},

		clearData() {
			this.imsi = "";
			this.state = "";
			(this.technology = ""), (this.msisdn = "");
			this.mdn = "";
			this.min = "";
			this.eprl = "";
			this.eprl_options = [];
			this.oplmn = "";
			this.oplmn_options = [];
			this.fplmn = "";
			this.fplmn_options = [];
			this.hplmn = "";
			this.hplmn_options = [];
			this.mspl = "";
			this.mspl_options = [];
			this.httppoll = "";
			this.httppoll_options = [];
			this.tls = "";
			this.kic = "";
			this.kid = "";
			this.vendor = "";
			this.vendor_options = [];
			this.can_httpota = 0;
			this.smsota = 0;
			this.reissue = 0;
			this.reset = 0;
			this.default_options = [];
			this.data_set = [];
			this.activated = true;
		},

		async loadPageData() {
			try {
				if (!this.iccid || this.iccid.length !== 20) {
					throw new Error("Invalid ICCID.");
				} else {
					this.getProfileData();
					//this.getCarrierData();
					this.writeCache();
				}
			} catch (e) {
				//this.showToasterMsg('[loadPage]Error:' + e.message, true, 'danger');
			}
		},

		async buildFilter(retry) {
			let force = 0;
			if (retry && retry > 0) force = 1;

			let json = new Object();
			json.type = "ota";
			json.method = "activate";
			//json.force = `${force}`;
			json.force = 1; //always force the ota

			if (this.iccid && this.iccid !== "") {
				json.iccid = this.iccid;
			}

			if (this.carrier && this.carrier !== "") {
				json.carrier = this.carrier;
			}
			if (this.msisdn && this.msisdn !== "") {
				json.msisdn = this.msisdn;
			}
			if (this.mdn && this.mdn !== "") {
				json.mdn = this.mdn;
			}
			if (this.min && this.min !== "") {
				json.min = this.min;
			}

			// dynamically set payload if there's an update in value
			// console.log("FILES MODEL", this.files_model.length);
			// console.log("FILES MODEL DEFAULT", this.files_model_default.length);
			this.files_model.forEach((file, i) => {
				let found = false;
				this.files_model_default.forEach((def, j) => {
					if (file.key == def.key) {
						found = true;
						// console.log("CURRENT", file);
						// console.log("DEFAULT", def);
						if (file.value && file.value !== "" && def.value != file.value) {
							json[file.key] = file.value;
						}
						if (file.val && def.value != file.value) {
							json[file.key] = file.value;
						}
					}
				});
				if (!found) {
					// console.log("NOT DEFAULT: ", file);
					if (file.value && file.value !== "") {
						json[file.key] = file.value;
					}
					if (file.val) {
						json[file.key] = file.value;
					}
				}

				// if (this.files_model_default[i]) {
				//   if (file.value && file.value !== "" && this.files_model_default[i].value != file.value) {
				//     json[file.key] = file.value;
				//   }
				//   if (file.val && this.files_model_default[i].value != file.value) {
				//     json[file.key] = file.value;
				//   }
				// } else {
				//   console.log("NOT DEFAULT: ", file);
				//   if (file.value && file.value !== "") {
				//     json[file.key] = file.value;
				//   }
				//   if (file.val) {
				//     json[file.key] = file.value;
				//   }
				// }
			});

			this.item_keys.forEach((item, i) => {
				if (item.value != this[item.key]) {
					json[item.key] = item.value;
				}
				if ("vendor" == item.key) {
					json[item.key] = item.value;
				}
			});
			// end dynamically set payload if there's an update in value -- Noriel F.

			if (
				this.smsota &&
				this.smsota !== "" &&
				this.data_set.items.data.hasOwnProperty("smsota") &&
				this.data_set.items.data["smsota"] !== this.smsota
			) {
				json.smsota = this.smsota;
			}

			if (
				this.can_httpota &&
				this.can_httpota !== "" &&
				this.data_set.items.data.hasOwnProperty("can_httpota") &&
				this.data_set.items.data["can_httpota"] !== this.can_httpota
			) {
				json.can_httpota = this.can_httpota;
			}

			if (
				this.reissue &&
				this.reissue !== "" &&
				this.data_set.items.data.hasOwnProperty("reissue") &&
				this.data_set.items.data["reissue"] !== this.reissue
			) {
				json.reissue = this.reissue;
			}
			if (
				this.reset &&
				this.reset !== "" &&
				this.data_set.items.data.hasOwnProperty("reset") &&
				this.data_set.items.data["reset"] !== this.reset
			) {
				json.reset = this.reset;
			}
			//this.filterSize = Object.keys(json).length;
			//this.filter;
			//console.log(JSON.stringify(json));
			return JSON.stringify(json);
		},

		async getProfileData() {
			this.submitLoading = true;
			this.iccid = this.iccid.substring(0, 20);
			this.writeCache();
			this.clearData();
			await otaDashboardService.query_minimal(this.iccid).then(async res => {
				//console.log('otActivate: getProfileData');
				//console.log(res);
				if (res.data.error) {
					this.btn_disabled = true;
					if (this.iccid === "") {
						this.systemMessage = "Please enter a valid iccid that exists in the system.";
					} else {
						//this.systemMessage = 'This iccid is in a disabled state and cannot be activated.';
						this.systemMessage = "This " + res.data.error_string + " and cannot be activated.";
					}
					//this.showToasterMsg(this.systemMessage,false,'warning');
					this.hasData = false;
					return;
				}

				if (res.data.result) {
					if (res.data.result.items.data.hasOwnProperty("disabled")) {
						if (res.data.result.items.data.disabled > 0) {
							this.btn_disabled = true;
							this.showToasterMsg(
								"This iccid is in a disabled state and cannot be activated.",
								false,
								"warning"
							);
							return;
						}
					}

					if (res.data.result.items.data.hasOwnProperty("transferred")) {
						if (res.data.result.items.data.transferred > 0) {
							this.btn_disabled = true;
							this.showToasterMsg(
								"This iccid is in a transferred state and cannot be activated.",
								false,
								"warning"
							);
							return;
						}
					}

					if (res.data.result.items.data.hasOwnProperty("activated")) {
						if (res.data.result.items.data.activated) {
							this.btn_disabled = true;
							this.showToasterMsg(
								"This iccid is in an activated state and cannot be activated, you must reset before activating again..",
								false,
								"warning"
							);
							return;
						}
					}

					// console.log('activated:', res.data.result.items.data);
					if (res.data.result.items.data.hasOwnProperty("activated")) {
						this.activated = res.data.result.items.data.activated;
					} else {
						this.activated = true;
					}

					this.data_set = res.data.result;

					//get lists
					if (res.data.result.carrier.files.hasOwnProperty("eprl"))
						this.eprl_options = this.returnArrMap(res.data.result.carrier.files.eprl);
					//else
					this.eprl_options.unshift({value: "", text: "Not Set"});

					if (res.data.result.carrier.files.hasOwnProperty("oplmn"))
						this.oplmn_options = this.returnArrMap(res.data.result.carrier.files.oplmn);
					//else
					this.oplmn_options.unshift({value: "", text: "Not Set"});

					if (res.data.result.carrier.files.hasOwnProperty("fplmn"))
						this.fplmn_options = this.returnArrMap(res.data.result.carrier.files.fplmn);
					//else
					this.fplmn_options.unshift({value: "", text: "Not Set"});

					if (res.data.result.carrier.files.hasOwnProperty("hplmn"))
						this.hplmn_options = this.returnArrMap(res.data.result.carrier.files.hplmn);
					//else
					this.hplmn_options.unshift({value: "", text: "Not Set"});

					if (res.data.result.carrier.files.hasOwnProperty("mspl"))
						this.mspl_options = this.returnArrMap(res.data.result.carrier.files.mspl);
					//else
					this.mspl_options.unshift({value: "", text: "Not Set"});

					//get opl
					if (res.data.result.carrier.files.hasOwnProperty("opl"))
						this.opl_options = this.returnArrMap(res.data.result.carrier.files.opl);
					//else
					this.opl_options.unshift({value: "", text: "Not Set"});

					//get pnn
					if (res.data.result.carrier.files.hasOwnProperty("pnn"))
						this.pnn_options = this.returnArrMap(res.data.result.carrier.files.pnn);
					//else
					this.pnn_options.unshift({value: "", text: "Not Set"});

					// Set Item data - Noriel F.
					if (res.data.result.items.data) {
						for (const [key, value] of Object.entries(res.data.result.items.data)) {
							let val = value;
							if (key === "httppoll") {
								val = value.name;
							} else if (key === "domain") {
								// console.log("domain:", value.data);
								val = value.data;
							}

							this.item_data.push({
								key: key,
								value: val,
							});
						}
					}
					// get and set files and model - Noriel F.
					this.files = res.data.result.carrier.files;
					for (const [key, value] of Object.entries(this.files)) {
						let itemData = this.item_data.find(id => id.key == key);
						let val = value.find(v => v.value && v.value != "");
						let def = value.find(v => v.default && v.default == true);
						let data = value.find(v => v.data && v.data != "");

						let model = {
							key: key,
							value: itemData
								? itemData.value
								: val
									? val.value
									: data && key.toString().toLowerCase() != "httppoll"
										? data.data
										: def
											? def.name
											: "",
							val: val ? val.value : false,
							data: data ? data.data : def ? def.name : "",
						};

						if (key === "isimimsi") {
							// console.log(model);
							// console.log(def, data);
							model.value = {data: model.val};
						}

						this.files_model.push(model);
					}
					// this.files_model_default = JSON.parse(JSON.stringify(this.files_model));
					// console.log(res.data.result.carrier.files);
					for (const key in res.data.result.carrier.files) {
						for (const [i, value] of res.data.result.carrier.files[key].entries()) {
							if (value.default) {
								this.files_model_default.push({
									key: key,
									value: value.name,
									val: value.value,
									data: value.data,
								});
							}
						}
					}
					// end get and set files and model - Noriel F.

					// Set Item Keys - Noriel F.
					if (res.data.result.items.keys) {
						for (const [key, value] of Object.entries(res.data.result.items.keys)) {
							this.item_keys.push({
								key: key,
								value: value,
							});
						}
					}

					//TODO: verifiy if this override is correct.
					// console.log('vendor_options:',res.data.result.carrier.files.vendor);
					// if (res.data.result.carrier.files.hasOwnProperty('vendor'))
					//   this.vendor_options = this.returnArrMap(res.data.result.carrier.files.vendor);
					// else {
					// if (res.data.result.carrier.hasOwnProperty("vendor")) {
					//   this.vendor_options = [
					//     {
					//       value: res.data.result.carrier.vendor,
					//       text: res.data.result.carrier.vendor.toUpperCase()
					//     }
					//   ];
					// } else {
					// this.vendor_options = [
					// 	{value: "default", text: "Default (Simulity)"},
					// 	{value: "gemalto", text: "Gemalto"},
					// 	{value: "simulity", text: "Simulity"},
					// 	{value: "simulitylte", text: "Simulity LTE"},
					// 	{value: "unitedesim", text: "United Esim"},
					// 	{value: "esim", text: "ESIM"},
					// 	{value: "execulinknsim", text: "ExeculinkNSIM"},
					// ];
					// }
					//}

					// get list of vendors
					await otaDashboardService.getVendors().then(res => {
						// console.log("Vendors:", res);
						if (res.data.result) {
							res.data.result.map(vendor => {
								if (vendor.display_name.toLowerCase() !== "default") {
									this.vendor_options.push({
										value: vendor.name,
										text: vendor.display_name,
									});
								} else {
									this.vendor_options.push({value: "default", text: `Default (${vendor.name})`});
								}
							});
						}
					});

					//carrier fields
					if (res.data.result.carrier.hasOwnProperty("display_name"))
						this.carrier = res.data.result.carrier.display_name;
					else this.carrier = "";

					// if (this.carrier.toLowerCase().includes('esim')) {
					//   //hide the mdn, min
					// }

					// console.log('vendor:',res.data.result.items);

					if (res.data.result.items.keys && res.data.result.items.keys.hasOwnProperty("vendor"))
						this.vendor = res.data.result.items.keys.vendor;
					else this.vendor = "";

					//data fields
					if (res.data.result.items.data.hasOwnProperty("msisdn"))
						this.msisdn = res.data.result.items.data.msisdn;
					else this.msisdn = "";

					if (res.data.result.items.data.hasOwnProperty("mdn")) this.mdn = res.data.result.items.data.mdn;
					else this.mdn = "";

					if (res.data.result.items.data.hasOwnProperty("min")) this.min = res.data.result.items.data.min;
					else this.min = "";

					if (res.data.result.items.data.hasOwnProperty("eprl")) this.eprl = res.data.result.items.data.eprl;
					else if (this.eprl_options.length > 0) this.eprl = this.eprl_options[0].value;

					if (res.data.result.items.data.hasOwnProperty("oplmn"))
						this.oplmn = res.data.result.items.data.oplmn;
					else if (this.oplmn_options.length > 0) this.oplmn = this.oplmn_options[0].value;

					if (res.data.result.items.data.hasOwnProperty("fplmn"))
						this.fplmn = res.data.result.items.data.fplmn;
					else if (this.fplmn_options.length > 0) this.fplmn = this.fplmn_options[0].value;

					if (res.data.result.items.data.hasOwnProperty("hplmn"))
						this.hplmn = res.data.result.items.data.hplmn;
					else if (this.hplmn_options.length > 0) this.hplmn = this.hplmn_options[0].value;

					if (res.data.result.items.data.hasOwnProperty("mspl")) this.mspl = res.data.result.items.data.mspl;
					else if (this.mspl_options.length > 0) this.mspl = this.mspl_options[0].value;

					if (res.data.result.carrier.files.hasOwnProperty("httppoll"))
						this.httppoll_options = this.returnArrMapHttppoll(res.data.result.carrier.files.httppoll);
					else this.httppoll_options.unshift({value: "default", text: "default"});
					if (res.data.result.items.data.hasOwnProperty("httppoll"))
						this.httppoll = res.data.result.items.data["httppoll"]["name"];
					else this.httppoll = "default";

					if (res.data.result.items.data.hasOwnProperty("smsota"))
						this.smsota = res.data.result.items.data["smsota"];
					else this.smsota = "";

					if (res.data.result.items.data.hasOwnProperty("can_httpota"))
						this.can_httpota = res.data.result.items.data["can_httpota"];
					else this.can_httpota = "";

					if (res.data.result.items.data.hasOwnProperty("reissue"))
						this.reissue = res.data.result.items.data["reissue"];
					else this.reissue = "";

					if (res.data.result.items.data.hasOwnProperty("reset"))
						this.reset = res.data.result.items.data["reset"];
					else this.reset = "";

					//key fields
					if (res.data.result.items.keys && res.data.result.items.keys.hasOwnProperty("tls"))
						this.tls = res.data.result.items.keys.tls;
					else this.tls = "";

					if (res.data.result.items.keys && res.data.result.items.keys.hasOwnProperty("kic"))
						this.kic = res.data.result.items.keys.kic;
					else this.kic = "";

					if (res.data.result.items.keys && res.data.result.items.keys.hasOwnProperty("kid"))
						this.kid = res.data.result.items.keys.kid;
					else this.kid = "";

					this.hasData = true;
				} else {
					this.hasData = false;
					this.systemMessage = "Please enter a valid iccid that exists in the system.";
					//this.showToasterMsg(this.systemMessage,false,'warning');
				}

				//set the technology
				if (res.data.result.carrier.technology) this.technology = res.data.result.carrier.technology[0];
			});

			//update the state
			await this.updateMobilState();

			this.submitLoading = false;
		},

		newReturnArrMap(arr, filetype) {
			let obj = new Array();
			obj = filetype != "httppoll" ? this.returnArrMap(arr) : this.returnArrMapHttppoll(arr);
			obj.unshift({value: "", text: "Not Set"});
			return obj;
		},

		returnArrMap(arr) {
			//console.log('returnArrMap:(raw)',arr)
			let obj = new Array();
			arr.forEach(item => {
				if (item.hasOwnProperty("data")) {
					let row = {value: item.data, text: item.display_name + " (" + item.data + ")"};
					obj.push(row);
				} else {
					let row = {value: item.name, text: item.display_name};
					obj.push(row);
				}
			});
			return obj;
		},

		returnArrMapHttppoll(arr) {
			//console.log('returnArrMap:(raw)',arr)
			let obj = new Array();
			arr.forEach(item => {
				if (item.hasOwnProperty("data")) {
					let row = {value: item.name, text: item.display_name + " (" + item.data + ")"};
					obj.push(row);
				} else {
					let row = {value: item.name, text: item.display_name};
					obj.push(row);
				}
			});
			return obj;
		},

		refreshPage() {
			setTimeout(() => {
				//another way to refresh table data...
				//this.$root.$emit('bv::refresh::table', 'my-table');
				//this.$refs.table.refresh()
				this.profile_data_src = null;
				this.loadPageData();
			}, 1000);
		},

		showToasterMsg(message, append = false, variant = "success") {
			//console.log('showing toaster...')
			//commonService.showToasterMsg(message, append, variant);
			this.$toast(message, {type: variant});
		},

		clickRecords() {
			this.$router.push({path: `/ota/profile/:?iccid=${this.iccid}`});
		},

		async clickReset() {
			this.$bvModal.hide("confirm-reset");
			this.$root.$emit("loadingPanelShow", true);
			await otaDashboardService.reset(this.iccid).then(res => {
				setTimeout(() => {
					this.$root.$emit("loadingPanelHide", true);
				}, 300);
				if (res.data.status === true) {
					this.$toast.success({
						component: ToastVue,
						props: {
							description: "Successfully, Reset",
						},
					});
					this.loadPageData();
				}
			});
		},

		async activateAction(retry) {
			this.$root.$emit("loadingPanelShow", true);
			this.btn_disabled = true;
			let filter = await this.buildFilter(retry);
			// console.log('filter:',filter);
			await otaDashboardService
				.activate(filter)
				.then(async res => {
					if (res.data.hasOwnProperty("error")) {
						//console.log('Activation ERROR:',res);
						throw this.iccid + " : " + res.data.error + ": " + res.data.error_string;
					} else {
						authService.setActivityLog("OTA:Activate", "Activation was successful for: " + this.iccid, 0);
						//console.log('Activation OK:',res);

						this.showToasterMsg("Activation was successful for: " + this.iccid);
						await this.loadPageData();
					}
				})
				.catch(e => {
					authService.setActivityLog("OTA:Activate", JSON.stringify(e), 1);
					//console.error('Activation error:',e);
					let msg = 'The activation failed with message:"' + e + '"';
					if (retry > 0) {
						this.showToasterMsg(msg, false, "error");
					} else {
						msg += "  Would you like to retry?";
						this.$bvModal
							.msgBoxConfirm(msg, {
								title: "Error",
								size: "sm",
								buttonSize: "sm",
								okVariant: "danger",
								okTitle: "RETRY",
								cancelTitle: "CANCEL",
								footerClass: "p-2",
								hideHeaderClose: false,
								centered: true,
							})
							.then(value => {
								if (value === true) {
									this.activateAction(1);
								}
							});
					}
				})
				.finally(() => {
					this.btn_disabled = false;
					this.$root.$emit("loadingPanelHide", true);
				});
			// await this.loadPageData();
			// this.btn_disabled = false;

			// setTimeout(() => {
			// 	this.$root.$emit("loadingPanelHide", true);
			// }, 300);
		},

		async updateMobilState() {
			//if (!this.carrier.toLowerCase().includes("inland")) return;

			// // step 1:  get current status from the mnet hss or dcc inventory
			//
			// //a. inventory
			// //LookupSubscriber
			// await searchDashboardService.getLookupSubscriber('','',this.iccid).then(res => {
			//   console.log(res);
			//   // //b. mnet
			//   // LookupSubscriberMnetHss
			//
			//   // c. Summa
			//   // LookupSubscriberSummaHss
			//
			//   if (res.data.message.results[0].imsi) this.imsi = String(res.data.message.results[0].imsi);
			//
			// });

			try {
				//get the imsi from esim
				await eSimDashboardService.getProfile(this.iccid).then(res => {
					// console.log(res);
					if (res.data.imsi) this.imsi = String(res.data.imsi);
				});
				if (!this.imsi) {
					throw new Error("IMSI missing " + this.imsi);
				}
				//get state from mobile system
				this.state = "INVALID";
				await mobileDashboardService.simple_getstate(this.imsi).then(res => {
					this.state = String(res.data.message).toUpperCase();
				});
			} catch (e) {
				console.warn(e);
				this.state = "INVALID";
			}
		},

		async provisionAction(action) {
			this.$root.$emit("loadingPanelShow", true);
			try {
				//get the imsi from esim
				let imsi = this.imsi;
				let state = this.state;
				let product = "mns01";
				let iccid = this.iccid;
				let msisdn = this.msisdn;
				let simtype = this.vendor;
				if (!iccid) {
					throw "ICCID missing " + iccid;
				}
				// if (simtype.toLowerCase() !== 'esim') {
				//   throw 'NOT valid simType ' + simtype;
				// }
				// //get the imsi from esim
				// await eSimDashboardService.getProfile(this.iccid).then(res => {
				//   console.log(res);
				//   if (res.data.imsi) imsi = String(res.data.imsi);
				// });
				// if (!imsi) {
				//   throw 'IMSI missing ' + imsi;
				// }
				//
				// let state = 'INVALID';
				// await mobileDashboardService.simple_getstate(imsi).then(res => {
				//   state = res.data.message;
				// });

				//do the action next
				if (action === "ACTIVATE") {
					if (String(state).toUpperCase() !== "INACTIVE" && String(state).toUpperCase() !== "INVENTORY") {
						throw "IMSI is not in a valid state: " + state;
					}

					//validate msisdn  and format
					if (!msisdn) {
						throw "MSISDN missing " + msisdn;
					} else {
						msisdn = "1" + msisdn.replace(/\D/g, "");
					}
					//activate
					await mobileDashboardService.simple_activate(imsi, msisdn, product, simtype).then(res => {
						if (JSON.stringify(res).includes("FAIL")) {
							throw String(res.data.message);
						}
					});
					authService.setActivityLog(action, "Action was successful for: " + this.iccid, 0);
					this.showToasterMsg(action + " was successful for: " + this.iccid);
				} else {
					//TERMINATE
					// if (String(state).toUpperCase() !== 'ACTIVE') {
					//   throw 'IMSI is not in a valid state: ' + state;
					// }
					await mobileDashboardService.simple_terminate(imsi).then(res => {
						if (JSON.stringify(res).includes("FAIL")) {
							throw String(res.data.message);
						}
					});
					authService.setActivityLog(action, "Action was successful for: " + this.iccid, 0);
					this.showToasterMsg(action + " was successful for: " + this.iccid);
				}
			} catch (e) {
				authService.setActivityLog(action, "Action FAILED for: " + this.iccid + " " + JSON.stringify(e), 1);
				this.showToasterMsg(action + " FAILED for: " + this.iccid + " " + JSON.stringify(e), false, "error");
			}

			//update the state
			await this.updateMobilState();

			setTimeout(() => {
				this.$root.$emit("loadingPanelHide", true);
			}, 300);
		},
	},
};
</script>
<style lang="scss" scoped>
:deep(.custom-toggle) {
	input {
		&:checked {
			+ .custom-toggle-slider {
				&:before {
					transform: translateX(50px);
				}
			}
		}
	}
}
</style>
